import { Condition, ConditionGroup, MediaElement } from 'editor/src/store/design/types';
import { conditionExportFilename, serializeCondition } from 'editor/src/store/design/util/conditionTransfer';

/**
 * Triggers a browser download of `condition` as a portable JSON file (see
 * conditionTransfer for the shape) — the condition itself plus everything on
 * `mediaElements` (its owning spread) linked to it. DOM-only side effect, kept
 * out of the pure serializer so that one stays unit-testable without a document.
 */
function downloadCondition(condition: Condition, conditionGroup: ConditionGroup, mediaElements: MediaElement[]) {
  const file = serializeCondition(condition, conditionGroup, mediaElements);
  const blob = new Blob([JSON.stringify(file, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = conditionExportFilename(condition.name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  // Not revoked synchronously: Firefox, Safari and embedded webviews start
  // the download after click() returns, and a revoked URL saves nothing.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export default downloadCondition;
